import React from "react";
import {GridTaskLike} from "ts/api/grid-task-like";
import DataRow from "view/components/DataRow";
import GridIcon from "view/images/GridIcon";
import {useCurrentShowId} from "hooks";
import IconButton from "@material-ui/core/IconButton";
import LaunchIcon from "@material-ui/icons/Launch";
import {makeStyles, Tooltip, Typography} from "@material-ui/core";
import useOpenGrid from "tools/openGrid";
import {useTranslate} from "@tolgee/react";

type CutGridProps = {
  task: GridTaskLike;
  /** task_responses.id of the shown version — drives the "Open Grid" window. */
  responseId?: string;
};

function CutGrid({task, responseId}: CutGridProps) {
  const showId = useCurrentShowId();
  const openGrid = useOpenGrid(showId);
  const classes = useStyles();
  const {t} = useTranslate();
  const gridLabel = t("common.tasks.grid.title");

  return (
    <DataRow
      classes={{row: classes.root}}
      label={gridLabel}
      value={
        <Tooltip title={task.gridSchema?.name || ""}>
          <Typography className={classes.gridName} noWrap>
            {task.gridSchema?.name || gridLabel}
          </Typography>
        </Tooltip>
      }
      icon={<GridIcon className={classes.icon} />}
      actionPanel={
        <IconButton disabled={!responseId} onClick={() => openGrid(responseId)}>
          <LaunchIcon />
        </IconButton>
      }
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: "none !important",
  },
  icon: {
    "& path": {
      fill: theme.palette.primary.main,
    },
  },
  gridName: {
    fontWeight: 500,
  },
}));

export default CutGrid;
